import {HttpParams} from "@angular/common/http";
import {Countries} from "../config";
import {AssetFilterEnum, AssetTypeFilterEnum, BaseFilterEnum} from "../enums";
import {LockStatusFilterEnum} from "../enums/filters/lock-status-filter.enum";
import {FilterInterface, TagFilter} from "../interfaces";

export const prepareFiltersForParams = (filters: FilterInterface): HttpParams => {
  let params = new HttpParams();

  const keys = Object.keys(filters);
  keys.forEach(key => {
    //Skip Filters with Empty or Null Values
    if (filters[key] === null || filters[key] === undefined || filters[key] === "") {
      return;
    }

    //Incomplete Datasets Filter should not send a false value, so skip it instead
    if (key === AssetTypeFilterEnum.Incomplete_Datasets && !filters[key]) {
      return;
    }

    //Transform Order Tracking filter values: "active" → "Exclusive", "inactive" → "None"
    if (key === AssetFilterEnum.In_Order_Tracking) {
      const value = filters[key] as string;
      if (value === "active") {
        params = params.append(key, "Exclusive");
      } else if (value === "inactive") {
        params = params.append(key, "None");
      }
      return;
    }

    //Transform Array Data for Sort Fields and Sort Directions into Query Params
    if (key === BaseFilterEnum.Sort_By || key === BaseFilterEnum.Sort_Desc) {
      (filters[key] as Array<string>).forEach((field, index) => {
        params = params.append(key + `[${index}]`, field);
      });
      return;
    }

    // Only string/number/boolean filter values are serialised; any other typeof
    // result (bigint, symbol, undefined, object, function) is intentionally ignored.
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (typeof filters[key]) {
      case "string":
        params = params.append(key, filters[key] as string);
        break;
      case "number":
        params = params.append(key, (filters[key] as number).toString());
        break;
      case "boolean":
        params = params.append(key, (filters[key] as boolean) ? "true" : "false");
        break;
      default:
        return;
    }

    //Transform Search Input into Query Format
    if (key === BaseFilterEnum.Query_Filter) {
      let searchTerm = filters[key] as string;
      searchTerm = searchTerm.trim();
      searchTerm = searchTerm.replace(/\s+/g, " ");
      let terms = searchTerm.split(" ");
      let query = "";
      terms = terms.filter(x => x !== "");
      terms.forEach(term => {
        query += `${term}* `;
      });
      params = params.set(BaseFilterEnum.Query_Filter, query);
    }
  });

  return params;
};

export const getTagFilterValue = (tag: TagFilter) => {
  tag.active = !tag.active;
  let filterValue: boolean | string;
  if (tag.activeValue || tag.inactiveValue) {
    if (tag.active && tag.activeValue) {
      filterValue = tag.activeValue.toString();
    } else if (!tag.active && tag.inactiveValue) {
      filterValue = tag.inactiveValue.toString();
    } else {
      filterValue = "";
    }
  } else {
    filterValue = tag.active;
  }

  return filterValue;
};

export function defaultFilterDisplayTransform(filterValue: string): string {
  return filterValue;
}

export function countryFilterDisplayTransform(filterValue: string): string {
  return Countries.filter(x => x.shortCode === filterValue)[0].name;
}

export function lockStatusFilterEnumTransform(filterValue: string): string {
  let label = "";
  switch (filterValue as LockStatusFilterEnum) {
    case LockStatusFilterEnum.Unlocked:
      label = "Unlocked";
      break;
    case LockStatusFilterEnum.Manual:
      label = "Manual";
      break;
    case LockStatusFilterEnum.New:
      label = "New";
      break;
    case LockStatusFilterEnum.Locked:
      label = "Locked";
      break;
    case LockStatusFilterEnum.All:
      label = "All";
  }
  return label;
}

export function orderTrackingFilterDisplayTransform(filterValue: string): string {
  if (filterValue === "active") {
    return "Order Tracking Active";
  } else if (filterValue === "inactive") {
    return "Order Tracking Inactive";
  }
  return "";
}
